const sortCollocates = (termFrequency) => {
	return Object.keys(termFrequency).map( key => ({
		key,
		frequency: termFrequency[key]
	})).sort( (a, b) => b.frequency - a.frequency)
}

export default function compileCollection ({language, query, mode, results}) {
	// console.debug(`mode = ${mode}, in compileCollection, results = ${results}`)
	if (mode !== 'equalsto' || language !== 'en') {
		return null
	}
	// console.debug(`in compileCollection, language = ${language}, results = %o`, results)
	// const regex = '(?:(\\w+)[\\W]+)?(?:(\\w+)[\\W]+)?\\b' + query + '\\b(?:[\\W]+(\\w+))?(?:[\\W]+(\\w+))?'
	const regexPostMatch = '\\b' + query + '\\b(?:[\\W]+([\\w\'\-]+))?(?:[\\W]+([\\w\'\-]+))?(?:[\\W]+([\\w\'\-]+))?(?:[\\W]+([\\w\'\-]+))?(?:[\\W]+([\\w\'\-]+))?(?:[\\W]+([\\w\'\-]+))?'
	const regexPreMatch = '(?:([\\w\'\-]+)[\\W]+)?(?:([\\w\'\-]+)[\\W]+)?(?:([\\w\'\-]+)[\\W]+)?(?:([\\w\'\-]+)[\\W]+)?(?:([\\w\'\-]+)[\\W]+)?(?:([\\w\'\-]+)[\\W]+)?\\b' + query + '\\b'
	const rePreMatch = new RegExp(regexPreMatch, 'i')
	const preMatches = results.map( m => {
		const match = rePreMatch.exec(m.en || m.text)
		// console.debug(`match = %o`, match)
		if (match) {
			return match.slice(1,7).filter( s => !!s)
		} else {
			// console.debug(`match is null`)
			return []
		}
	})
	// console.debug(`preMatches = %o`, preMatches)
	const rePostMatch = new RegExp(regexPostMatch, 'i')
	// const postMatches = results.map( m => rePostMatch.exec(m.en || m.text).slice(1,7).filter(s => !!s) )

	const postMatches = results.map( m => {
		const match = rePostMatch.exec(m.en || m.text)
		// console.debug(`match = %o`, match)
		if (match) {
			return match.slice(1,7).filter( s => !!s)
		} else {
			// console.debug(`match is null`)
			return []
		}
	})

	// console.debug(`postMatches = %o`, postMatches)
	// console.debug(`postMatches = ${JSON.stringify(postMatches)}`)
	const preCollocates = preMatches.reduce( (acc, v) => {
		const len = v.length
		// console.debug(`v = ${JSON.stringify(v)}`)
		v.map( (word, index) => {
			// console.debug(`word=${word}, index=${index}`)
			word = word.toLowerCase()
			acc[index + 6 - len] = acc[index + 6 - len] || {}
			if (typeof acc[index + 6 - len][word] !== 'undefined') {
				acc[index + 6 - len][word]++
			} else {
				acc[index + 6 - len][word] = 1
			}
		})
		// console.debug(`acc = ${JSON.stringify(acc)}`)
		return acc
	}, {})
	for (let i = 0; i <= 5; i++) {
		if (!preCollocates[i]) {
			preCollocates[i] = {}
		}
	}
	// console.debug(`preCollocates = %o`, preCollocates)

	const postCollocates = postMatches.reduce( (acc, v) => {
		// const len = v.length
		// console.debug(`v = ${JSON.stringify(v)}`)
		v.map( (word, index) => {
			// console.debug(`word=${word}, index=${index}`)
			word = word.toLowerCase()
			acc[index] = acc[index] || {}
			if (typeof acc[index][word] !== 'undefined') {
				acc[index][word]++
			} else {
				acc[index][word] = 1
			}
		})
		// console.debug(`acc = ${JSON.stringify(acc)}`)
		return acc
	}, {})
	// console.debug(`preCollocates[0] = %o`, sortCollocates(preCollocates[0]))
	// console.debug(`preCollocates[1] = %o`, sortCollocates(preCollocates[1]))
	// console.debug(`preCollocates[2] = %o`, sortCollocates(preCollocates[2]))
	// console.debug(`preCollocates[3] = %o`, sortCollocates(preCollocates[3]))
	// console.debug(`preCollocates[4] = %o`, sortCollocates(preCollocates[4]))
	// console.debug(`preCollocates[5] = %o`, sortCollocates(preCollocates[5]))
	// console.debug(`postCollocates[0] = %o`, sortCollocates(postCollocates[0]))
	// console.debug(`postCollocates[1] = %o`, sortCollocates(postCollocates[1]))
	// console.debug(`postCollocates[2] = %o`, sortCollocates(postCollocates[2]))
	// console.debug(`postCollocates[3] = %o`, sortCollocates(postCollocates[3]))
	// console.debug(`postCollocates[4] = %o`, sortCollocates(postCollocates[4]))
	// console.debug(`postCollocates[5] = %o`, sortCollocates(postCollocates[5]))

	// const collocateTableLength = Math.max([ ...preCollocates.map(v => Object.keys(v).length), ...postCollocates.map(v => Object.keys(v).length)])
	const preCollocatesByPosition = Object.keys(preCollocates).map(v => sortCollocates(preCollocates[v]))
	const postCollocatesByPosition = Object.keys(postCollocates).map(v => sortCollocates(postCollocates[v]))

	const collocateTableLength = Math.max(Math.max(...preCollocatesByPosition.map(v => v.length)), Math.max(...postCollocatesByPosition.map(v => v.length)))
	// console.debug(`preCollocatesByPosition = %o`, preCollocatesByPosition)
	// console.debug(`postCollocatesByPosition = %o`, postCollocatesByPosition)
	// console.debug(`collocateTableLength = ${collocateTableLength}`)
	let fullCollcates = [];

	for (let i = 0; i < collocateTableLength; i++) {
		fullCollcates.push([
			preCollocatesByPosition[0] ? preCollocatesByPosition[0][i] : null,
			preCollocatesByPosition[1] ? preCollocatesByPosition[1][i] : null,
			preCollocatesByPosition[2] ? preCollocatesByPosition[2][i] : null,
			preCollocatesByPosition[3] ? preCollocatesByPosition[3][i] : null,
			preCollocatesByPosition[4] ? preCollocatesByPosition[4][i] : null,
			preCollocatesByPosition[5] ? preCollocatesByPosition[5][i] : null,
			postCollocatesByPosition[0] ? postCollocatesByPosition[0][i] : null,
			postCollocatesByPosition[1] ? postCollocatesByPosition[1][i] : null,
			postCollocatesByPosition[2] ? postCollocatesByPosition[2][i] : null,
			postCollocatesByPosition[3] ? postCollocatesByPosition[3][i] : null,
			postCollocatesByPosition[4] ? postCollocatesByPosition[4][i] : null,
			postCollocatesByPosition[5] ? postCollocatesByPosition[5][i] : null
		])
	}

	// console.debug(`fullCollcates = %o`, fullCollcates)
	return fullCollcates
}